import { useCallback } from 'react'
import { getTerm, SCHOOL_FLAVOUR } from '@/lib/terminology'
import useAuth from './useAuth'

/**
 * Sector terminology for the ACTIVE org. Returns `t(key)` resolving terms for
 * the active org's flavour, plus the flavour itself. Safe before the active
 * org loads: falls back to school wording rather than erroring.
 *
 * For an org other than the active one (e.g. the site-admin feature-flag
 * editor), call `getTerm(org.flavour, key)` from `@/lib/terminology` directly.
 */
const useTerminology = () => {
    const { activeOrg } = useAuth()
    const flavour = activeOrg?.flavour || SCHOOL_FLAVOUR
    const t = useCallback((key) => getTerm(flavour, key), [flavour])
    return { t, flavour }
}

export default useTerminology
